import {
  Button,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import AddIdentification from "./AddIdentification";
import useAuth from "../../../components/hooks/useAuth";
import PhoneNumberInput from "../../../components/common/PhoneNumberInput";
import EmailAlreadyExistChecking from "../../../components/EmailAlreadyExistChecking";
import { getCustomerEmailChecking } from "../../../services/EmailChecking";
import { useTheme } from "../../../components/hooks/useTheme";
import { AddOutlined } from "@mui/icons-material";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import colorConfigs from "../../../configs/colorConfigs";
import { post_Customer } from "../../../services/customer";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";

type ExtraInformation = {
  id: number;
  idNumber: string;
  issueDate: string;
  exprationDate: string;
  filePath: string;
  idTypeId: string;
  customerId: number;
  type: string;
  imageSize: number,
  uploadedAt: string,
  uploadedBy: string
};

const monthNameOptions = [
  { value: "1", label: "1. January" },
  { value: "2", label: "2. February" },
  { value: "3", label: "3. March" },
  { value: "4", label: "4. April" },
  { value: "5", label: "5. May" },
  { value: "6", label: "6. June" },
  { value: "7", label: "7. July" },
  { value: "8", label: "8. August" },
  { value: "9", label: "9. September" },
  { value: "10", label: "10. October" },
  { value: "11", label: "11. November" },
  { value: "12", label: "12. December" },
];

const daysOptions: any = [];
for (let i = 1; i <= 31; i++) {
  daysOptions.push({ value: i, label: i });
}

const yearOptions: any = [];
for (let i = 1940; i <= new Date().getFullYear(); i++) {
  yearOptions.push({ value: i, label: i });
}

yearOptions.reverse();

export const AddCustomer = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { dateFormat }: any = useGeneral();
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [Street, setStreet] = useState<string>("");
  const [street2, setStreet2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [day, setDay] = useState<string>("");
  const [month, setMonth] = useState<string>("");
  const [year, setYear] = useState<string>("");
  const [isRedFlag, setIsRedFlag] = useState<boolean>(false);
  const [redFlagReason, setRedFlagReason] = useState<string>("");
  const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
  const [indexNumber, setIndexNumber] = useState<number>(1);
  const [emailTouched, setEmailTouched] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);


  const handleAddExtraRow = () => {
    const data: ExtraInformation = {
      id: indexNumber,
      idNumber: "",
      issueDate: "",
      exprationDate: "",
      filePath: "",
      idTypeId: "",
      customerId: 1,
      type: "POST",
      imageSize: 0,
      uploadedAt: moment(new Date()).format(dateFormat + " hh:mm:ss a"),
      uploadedBy: auth.givenname,
    };

    setExtraRow((extraRow: ExtraInformation[]) => [...extraRow, data]);

    setIndexNumber(indexNumber + 1);
  };

  const handleDeleteExtraRow = (index: number) => {
    const newRow: ExtraInformation[] = extraRow.filter((row: ExtraInformation) => row.id !== index)
    setExtraRow(newRow);
  };

  const changeOnExtraValue = (row: ExtraInformation) => {
    setExtraRow((extraRow) => extraRow.map((rowValue: ExtraInformation) => {
      return (rowValue.id === row.id) ? row : rowValue
    }))
  };


  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setPleaseWaitPopup(true);
    const customerExtraInformations = extraRow?.map((item: any) => {
      return {
        idNumber: item.idNumber,
        issueDate: new Date(item.issueDate),
        exprationDate: new Date(item.exprationDate),
        filePath: item.filePath,
        idTypeId: item.idTypeId,
        customerId: item.customerId,
        imageSize: item.imageSize,
        uploadedAt: new Date(item.uploadedAt),
        uploadedBy: item.uploadedBy
      }
    });

    await post_Customer({
      firstName,
      lastName,
      emailAddress,
      phoneNumber,
      Street,
      street2,
      city,
      state,
      country,
      zip,
      birthday: new Date(`${year}-${month}-${day}`),
      isRedFlag,
      redFlagReason,
      customerExtraInformations
    }, auth?.id, tenantId)
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Customer</h2>
                </div>
              </div>
              <div className="flex">
                <div className="mt-2 p-2 w-[70%]">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="w-full px-2">
                      <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                        Customer Information
                      </span>

                      <Divider className={`w-full ${themeStyles.divider.bg}`} />

                      <div className="w-full px-2">
                        <div className="grid grid-cols-2 gap-6 mb-2">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>First Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-6 mb-2">
                          <div>
                            <EmailAlreadyExistChecking
                              emailAddress={emailAddress}
                              setEmailAddress={setEmailAddress}
                              getEmailChecking={getCustomerEmailChecking}
                              className={{
                                label: {
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: themeStyles.form.labelTextColor
                                },
                                input: {
                                  width: "100%",
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  outline: "none",
                                  color: themeStyles.form.inputTextColor
                                },
                                successMessage: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '0.25rem',
                                  fontSize: '0.75rem',
                                  color: '#00b300',
                                },
                                errorMessage: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '0.25rem',
                                  fontSize: '0.75rem',
                                  color: '#ff3333',
                                },
                              }}
                              touched={emailTouched}
                              setTouched={setEmailTouched}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Phone Number</label>
                            <PhoneNumberInput
                              name={"phoneNumber"}
                              value={phoneNumber}
                              setValue={setPhoneNumber}
                              fontSize={"14px"}
                              paddingBlock={"5px"}
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-6 mb-2">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Street</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={Street}
                              onChange={(e) => setStreet(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Street 2</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={street2}
                              onChange={(e) => setStreet2(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-6 mb-2">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>City</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>State</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-6 mb-2">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Zip</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={zip}
                              onChange={(e) => setZip(e.target.value.replace(/\D/g, ""))}
                              inputMode="numeric"
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Country</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={country}
                              onChange={(e) => setCountry(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full mt-[16px] flex items-center gap-1.5">
                      <div className="w-[30%]">
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Birthday</label>
                        <Select
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: "transparent",
                              color: themeStyles.form.inputTextColor,
                              borderRadius: '6px',
                              padding: '1px',
                              borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "14px",
                              backgroundColor: themeStyles.main.mainBg,
                              color: themeStyles.form.inputTextColor,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? "#167AC3"
                                : state.isFocused
                                  ? themeStyles.topBar.menuItemsHoverColor
                                  : "transparent",
                              color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                              fontWeight: 600
                            }),
                            input: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,

                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,
                            }),
                          }}
                          className="basic-single"
                          classNamePrefix="select"
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={false}
                          name="birthday"
                          value={monthNameOptions.find(
                            (item) => item.value === month
                          )}
                          onChange={(month: any) =>
                            setMonth(month ? month.value : "")
                          }
                          options={monthNameOptions}
                          required
                        />
                      </div>

                      <div className="mt-6">
                        <Select
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: "transparent",
                              color: themeStyles.form.inputTextColor,
                              borderRadius: '6px',
                              padding: '1px',
                              borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "14px",
                              backgroundColor: themeStyles.main.mainBg,
                              color: themeStyles.form.inputTextColor,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? "#167AC3"
                                : state.isFocused
                                  ? themeStyles.topBar.menuItemsHoverColor
                                  : "transparent",
                              color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                              fontWeight: 600
                            }),
                            input: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,

                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,
                            }),
                          }}
                          className="basic-single"
                          classNamePrefix="select"
                          isDisabled={false}
                          isLoading={false}
                          isClearable={true}
                          isRtl={false}
                          isSearchable={true}
                          name="birthday"
                          value={daysOptions.find(
                            (item: any) => item.value === parseInt(day)
                          )}
                          onChange={(day: any) =>
                            setDay(day ? day.value : "")
                          }
                          options={daysOptions}
                          required
                        />
                      </div>

                      <div className="mt-6">
                        <Select
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              backgroundColor: "transparent",
                              color: themeStyles.form.inputTextColor,
                              borderRadius: '6px',
                              padding: '1px',
                              borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                            }),
                            menu: (base) => ({
                              ...base,
                              fontSize: "14px",
                              backgroundColor: themeStyles.main.mainBg,
                              color: themeStyles.form.inputTextColor,
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? "#167AC3"
                                : state.isFocused
                                  ? themeStyles.topBar.menuItemsHoverColor
                                  : "transparent",
                              color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                              fontWeight: 600
                            }),
                            input: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,

                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: themeStyles.form.inputTextColor,
                            }),
                          }}
                          className="basic-single"
                          classNamePrefix="select"
                          isDisabled={false}
                          isLoading={false}
                          isClearable={true}
                          isRtl={false}
                          isSearchable={true}
                          name="birthday"
                          value={yearOptions.find(
                            (item: any) => item.value === parseInt(year)
                          )}
                          onChange={(year: any) =>
                            setYear(year ? year.value : "")
                          }
                          options={yearOptions}
                          required
                        />
                      </div>
                    </div>

                    <div className="w-1/2 mt-4">
                      <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Is Red Flag{" "}
                        <div className="group relative inline-block">
                          <HelpOutlineOutlinedIcon sx={{ fontSize: "16px", cursor: "pointer" }} />

                          <span className={"absolute z-10 w-[150px] text-[10px] bg-white text-gray-600 text-center py-[5px] rounded border border-gray-400 bottom-full left-1/2 -ml-[75px] invisible group-hover:visible"}>
                            <span
                              className="absolute top-full left-[51%] -ml-[8px] border-8 border-transparent border-t-white z-10"
                            />
                            <span
                              className="absolute top-full left-1/2 -ml-[8px] border-10 border-transparent border-t-gray-400"
                            />
                            If set to Yes, this customer will not be able to book a reservation. If No, booking is allowed as usual.
                          </span>
                        </div>
                      </label>

                      <RadioGroup
                        row
                        value={isRedFlag ? "Yes" : "No"}
                        onChange={(e) => setIsRedFlag(e.target.value === "Yes" ? true : false)}
                      >
                        <FormControlLabel
                          value="Yes"
                          control={
                            <Radio
                              sx={{
                                color: "gray",
                                "&.Mui-checked": {
                                  color: "#167AC3",
                                },
                              }}
                            />
                          }
                          label="Yes"
                          sx={{
                            color: themeStyles.form.labelTextColor
                          }}
                        />

                        <FormControlLabel
                          value="No"
                          control={
                            <Radio
                              sx={{
                                color: "gray",
                                "&.Mui-checked": {
                                  color: "#167AC3",
                                },
                              }}
                            />
                          }
                          label="No"
                          sx={{
                            color: themeStyles.form.labelTextColor
                          }}
                        />
                      </RadioGroup>
                    </div>

                    {isRedFlag && (
                      <div className="w-1/2 mt-4">
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Red Flag Reason</label>
                        <textarea
                          rows={4}
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={redFlagReason}
                          onChange={(e) => setRedFlagReason(e.target.value)}
                        ></textarea>
                      </div>
                    )}

                    <span className={`text-[14px] font-semibold inline-block my-4 ${themeStyles.main.textHeadingColor}`}>
                      Extra Information
                    </span>

                    <Divider className={`w-full ${themeStyles.divider.bg}`} />
                    <div className="w-full mt-2">
                      <table className="min-w-full">
                        <tbody className="text-left">
                          <tr className={`border-b ${themeStyles.main.borderColor}`}>
                            <th className={`w-[15%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Type</th>
                            <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>ID Number</th>
                            <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Issued On</th>
                            <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Exp. Date</th>
                            <th className={`w-[25%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>File</th>
                          </tr>

                          {
                            extraRow?.map((row: ExtraInformation, index: number) => {
                              return (
                                <AddIdentification
                                  key={index}
                                  itemIndex={row.id}
                                  handleDeleteExtraRow={(index) => handleDeleteExtraRow(index)}
                                  birthDay={new Date(`${year}-${month}-${day}`).toDateString()}
                                  row={row}
                                  changeOnExtraValue={(
                                    row
                                  ) =>
                                    changeOnExtraValue(
                                      row
                                    )
                                  }
                                />
                              )
                            })
                          }
                        </tbody>
                      </table>

                      <div
                        className="group h-10 border-dashed !border-t-0 border border-[#D5D4D8] pt-1 flex justify-center items-center cursor-pointer"
                        onClick={() => {
                          handleAddExtraRow();
                        }}
                      >
                        <p className="text-xs text-center text-[#167AC3] cursor-pointer font-medium group-hover:font-bold group-hover:scale-125">
                          <AddOutlined
                            sx={{
                              fontSize: "16px",
                              textAlign: "center",
                            }}
                          />
                          Add another Identification
                        </p>
                      </div>

                      <div className="flex gap-4 mt-6">
                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.main.bg
                          }}
                          type="submit"
                        >
                          Save
                        </Button>

                        <Button variant="contained"
                          sx={{
                            backgroundColor: colorConfigs.btn.cancel.bg,
                            border: colorConfigs.btn.cancel.border,
                            color: colorConfigs.btn.cancel.color
                          }}
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </Button>
                      </div>

                    </div>
                  </form>
                </div>

                <div className="mt-2 p-2 w-[30%]">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
};
